import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import baseUrl from "../../../baseUrl";
import Spinner from "../../../Components/Spinner/Spinner";

const ExamUpdate = () => {
  const adminToken = JSON.parse(localStorage.getItem("EXAMNP:admin-token"));

  const [examTitle, setExamTitle] = useState("");
  const [examCenter, setExamCenter] = useState("");
  const [examCode, setExamCode] = useState("");
  const [examStartAt, setExamStartAt] = useState("");
  const [examEndAt, setExamEndAt] = useState("");
  const [examSubject, setExamSubject] = useState("");
  const [examInstruction, setExamInstruction] = useState("");

  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const { id } = useParams();

  //   get exam by id
  useEffect(() => {
    axios
      .get(`${baseUrl}/admin/get-exam-details/${id}`, {
        headers: {
          Authorization: `Bearer ${adminToken}`,
        },
      })
      .then((res) => {
        console.log(res.data.exam);
        setExamTitle(res.data.exam.examTitle);
        setExamCenter(res.data.exam.examCenter);
        setExamCode(res.data.exam.examCode);
        setExamStartAt(res.data.exam.examStartAt);
        setExamEndAt(res.data.exam.examEndAt);
        setExamSubject(res.data.exam.examSubject);
        setExamInstruction(res.data.exam.examInstruction);
      });
  }, [id, adminToken]);

  // handle submit for create exam
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post(
        `${baseUrl}/admin/update-exam/${id}`,
        {
          examTitle,
          examCenter,
          examStartAt,
          examEndAt,
          examSubject,
          examInstruction,
        },
        {
          headers: {
            Authorization: `Bearer ${adminToken}`,
          },
        }
      )
      .then((res) => {
        if (res.data.success === true) {
          toast.success(res.data.message);
          navigate("/admin/exams");
        } else {
          toast.error(res.data.message);
          navigate("/admin/exams");
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <>
      {loading && <Spinner />}
      <form onSubmit={handleSubmit}>
        <div className="relative p-6 flex-auto">
          <label
            className="block mb-2 text-sm font-bold text-gray-700"
            htmlFor="examTitle"
          >
            Exam Title
          </label>
          <input
            className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-green-500 border-green-300 focus:shadow-outline"
            type="text"
            name="examTitle"
            value={examTitle}
            onChange={(e) => setExamTitle(e.target.value)}
            required
          />
        </div>
        <div className="mb-4 md:flex">
          <div className="mb-4 md:mr-2 md:mb-0 ml-2">
            <label className="block mb-2 text-sm font-bold text-gray-700">
              Exam Code
            </label>
            <input
              className="w-full px-3 py-2 text-sm leading-tight  text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              type="text"
              name="examCode"
              value={examCode}
              disabled
              required
            />
          </div>
          <div className="mb-4 md:mr-2 md:mb-0">
            <label className="block mb-2 text-sm font-bold text-gray-700">
              Exam Center
            </label>
            <input
              className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              type="text"
              name="examCenter"
              value={examCenter}
              onChange={(e) => setExamCenter(e.target.value)}
              required
            />
          </div>
          <div className="mb-4 md:mr-2 md:mb-0">
            <label className="block mb-2 text-sm font-bold text-gray-700">
              Exam Subject
            </label>
            <input
              className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              type="text"
              name="examSubject"
              value={examSubject}
              onChange={(e) => setExamSubject(e.target.value)}
              required
            />
          </div>
        </div>

        <div className="mb-4 md:flex">
          <div className="pr-16 pl-4 mb-4 md:mr-2 md:mb-0 ml-2">
            <label className="block mb-2 text-sm font-bold text-gray-700">
              Exam Start At
            </label>
            <input
              className="w-full px-3 py-2 text-sm leading-tight focus:outline-green-500 border-green-300 text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              type="datetime-local"
              name="examStartAt"
              value={examStartAt}
              onChange={(e) => setExamStartAt(e.target.value)}
              required
            />
          </div>
          <div className="mb-4 md:mr-2 md:mb-0">
            <label className="block mb-2 text-sm font-bold text-gray-700">
              Exam End At
            </label>
            <input
              className="w-full px-3 py-2 focus:outline-green-500 border-green-300 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-none focus:shadow-outline"
              type="datetime-local"
              name="examEndAt"
              value={examEndAt}
              onChange={(e) => setExamEndAt(e.target.value)}
              required
            />
          </div>
        </div>
        <div className="relative p-6 flex-auto">
          <label
            className="block mb-2 text-sm font-bold text-gray-700"
            htmlFor="examTitle"
          >
            Exam Instruction
          </label>
          <textarea
            className="w-full px-3 py-2 text-sm leading-tight text-gray-700 border rounded shadow appearance-none focus:outline-green-500 border-green-300 focus:shadow-outline"
            name="examInstruction"
            value={examInstruction}
            onChange={(e) => setExamInstruction(e.target.value)}
            required
            rows="3"
          ></textarea>
        </div>
        {/*body*/}
        {/*footer*/}
        <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
          <button
            className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
            type="submit"
          >
            Save
          </button>
        </div>
      </form>
    </>
  );
};

export default ExamUpdate;
